import { useEffect } from 'react';

interface Props {
  appName?: string;
  favicon?: string;
}

const DEFAULT_FAVICON = '/favicons/clarix.svg';

export function DocumentMeta({ appName, favicon }: Props): null {
  useEffect(() => {
    document.title = appName ? `${appName} · Clarix` : 'Clarix';
  }, [appName]);

  useEffect(() => {
    const href = favicon ?? DEFAULT_FAVICON;
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = href;
  }, [favicon]);

  return null;
}
